import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SubscriptionCategory } from '../../../subscription.model';

@Component({
	selector: 'subscription-period-change',
	template: require('./subscription-period-change.html'),
	styles: [require('./subscription-period-change.scss')]
})
export class SubscriptionPeriodChangeComponent {
	@Input() categoryNames: SubscriptionCategory;
	@Output() periodChangeEmitter: EventEmitter<string> = new EventEmitter();

	constructor() {}

	emitPeriodChange(period: string): void {
		this.periodChangeEmitter.next(period);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/subscription/modals/subscription-modal/subscription-period-change/subscription-period-change.ts